<template>
  <div>
    <Form
      page-title="Edit Holiday"
      buttonName="Update"
      :businessId="businessId"
      :isInList="isInList"
      :model="model"
      @showAddChanged="$emit('showAddChanged', $event)"
      @submit="submit"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { updateHoliday } from "@/API/HolidaysAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Edit",
  components: { Form },
  props: ["isInList", "model", "businessId", "showAdd"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    submit(formData) {
      const updateData = {
        id: formData.id,
        from: formData.from,
        to: formData.to,
        user_id: formData.user_id,
        business_id: formData.business_id,
        locales: formData.locales,
        dateRange: {
          startDate: formData.dateRange.startDate,
          endDate: formData.dateRange.endDate
        },
        businessId: formData.business_id
      };

      const callback = () => {
        this.$emit("onSubmit");
        this.$emit("showAddChanged", !this.showAdd);
      };
      submitAndNotify(this, updateHoliday(updateData), callback);
    }
  }
};
</script>
<style></style>
